import {makeStyles} from "@mui/styles";
import React from "react";

const useStyles = makeStyles(
  () => ({
    legalBox: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-start",
      padding: "20px 50px",
    },
    termsContent: {
      color: "#3E4044",
      fontFamily: "sans-serif",
      fontSize: "16px",
      marginTop: "15px",
      width: "100%",
    },
    termsHeader: {
      color: "#3E4044",
      fontFamily: "sans-serif",
      fontSize: "22px",
      fontWeight: "bold",
    },
    termsSubContent: {
      color: "#58595e",
      fontSize: "14px",
    },
  }),
  {
    name: "Terms",
  }
);

export const Terms: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.legalBox}>
      <div className={classes.termsHeader}>
        Terms of service
        <div className={classes.termsContent}>
          <br />
          <p> Welcome to Checkafy! </p>

          <p className={classes.termsSubContent}>
            Checkafy provides technologies and services that allow people to
            shop more conveniently and satisfactorily.
          </p>

          <p className={classes.termsSubContent}>
            These Terms of Service define Checkafy’s relationship with you as
            you use Checkafy Services (the “Services”) on our applications and
            websites (the “Platforms”). These Services are provided by Lever
            Data Solutions Limited.
          </p>

          <br />

          <p> Registration </p>

          <p className={classes.termsSubContent}>
            When people stand behind their opinions and actions, Checkafy’s
            community is more accountable and reliable. For this reason, you are
            required to register with us when you use Checkafy Services.
          </p>

          <p className={classes.termsSubContent}>
            In consideration of your use of our Services, you agree to:
          </p>

          <p className={classes.termsSubContent}>
            1) provide true, accurate, current and complete information about
            yourself when registering (the &quot;Registration Data&quot;); and
          </p>

          <p className={classes.termsSubContent}>
            2) maintain and promptly update the Registration Data to keep it
            true, accurate, current and complete.
          </p>

          <p className={classes.termsSubContent}>
            If you provide any information that is untrue, inaccurate, not
            current or incomplete, or we have reasonable grounds to suspect that
            such information is untrue, inaccurate, not current or incomplete,
            we have the right to suspend or terminate your registration and
            refuse any current or future use of our Services.
          </p>

          <br />

          <p> Content </p>

          <p className={classes.termsSubContent}>
            To assist you in making better shopping decisions, Checkafy provides
            product information by displaying text, files, images, photos,
            sounds, videos or other materials (the “Content”) on Checkafy
            Platforms.
          </p>

          <p className={classes.termsSubContent}>
            We shall use all reasonable commercial endeavours to ensure the
            accuracy of the Content on our Platforms but give no warranties and
            make no representations, express or implied, statutory or otherwise
            regarding the accuracy, quality or completeness of the Content or
            its fitness for any purpose and we exclude any liability relating to
            it.
          </p>

          <p className={classes.termsSubContent}>
            You also agree that responsibility for the Content of advertisements
            appearing on our Platforms rests solely with the advertisers. The
            placement of such advertisements does not constitute a
            recommendation or endorsement by us of the advertisers’ products,
            and each advertiser is solely responsible for any representations
            made in connection with its advertisement. We do not accept
            responsibility for loss suffered as a result of reliance by you upon
            the accuracy of the information contained on our Platforms.
          </p>

          <p className={classes.termsSubContent}>
            Unless you have our express written consent or you are expressly
            authorised by law to do so, you shall not:
          </p>

          <p className={classes.termsSubContent}>
            1) use the Content for any commercial or other non-personal purpose;
          </p>

          <p className={classes.termsSubContent}>
            2) make any copies of the Content or transfer the Content to any
            other device or any other person; or
          </p>

          <p className={classes.termsSubContent}>
            3) otherwise reproduce, distribute, communicate to the public,
            modify, reformat, prepare derivative works of or display the
            Content.
          </p>

          <p className={classes.termsSubContent}>
            You acknowledge and agree that we may cease to supply any of the
            Content to you at our sole discretion if you are in breach of any of
            the terms of this clause.
          </p>

          <br />

          <p> User Generated Content </p>

          <p className={classes.termsSubContent}>
            Checkafy allows you to share your thoughts with other users. When
            you submit any user generated content including all text, files,
            images, photos, sounds, videos or other materials (the “User
            Content”) to Checkafy Platforms, you grant to us, a perpetual,
            irrevocable, non-exclusive, worldwide, transferable, sub-licensable
            fully paid-up and royalty-free licence to reproduce, distribute,
            communicate to the public, publicly perform, modify, prepare
            derivative works of, display and otherwise use the User Content in
            connection with our Platforms, including without limitation for the
            purposes of promoting and redistributing part or all of our
            Platforms in any media format and through any media channel.
          </p>

          <p className={classes.termsSubContent}>
            Without limitation, the rights that you grant to us under this
            clause include a right to grant each user of our Platforms a
            sub-licence to use the User Content to the extent permitted by the
            functionality of our Platforms from time to time.
          </p>

          <p className={classes.termsSubContent}>
            You hereby waive, and procure that all other authors of the User
            Content waive, all moral rights in the User Content (including
            rights to be identified as the author of the User Content or to
            object to any derogatory treatment of the User Content), whether
            such rights subsist now or at any time in the future in any place in
            the world.
          </p>

          <p className={classes.termsSubContent}>
            You represent, warrant and covenant that:
          </p>

          <p className={classes.termsSubContent}>
            1) you have the legal right and authority to grant the licence in
            this clause;
          </p>

          <p className={classes.termsSubContent}>
            2) you are the owner of the User Content and/or have all of the
            necessary rights, consents, permissions and licences which are
            required for you to grant us the licence in this clause;
          </p>

          <p className={classes.termsSubContent}>
            3) by exercising the licence in this clause, we shall not infringe
            the intellectual property rights or other rights of any third party;
          </p>

          <p className={classes.termsSubContent}>
            4) to the extent that the User Content identifies any individual
            (whether by name, picture or otherwise), you have obtained all
            consents and permissions from those individuals which are required
            for us to use the User Content as contemplated by the licence in
            this clause;
          </p>

          <p className={classes.termsSubContent}>
            5) the User Content does not include any material that may be
            illegal, defamatory, obscene, offensive, harmful to the safety of
            any person, aimed at harassing any person or otherwise is
            inappropriate for display on our Platforms; and
          </p>

          <p className={classes.termsSubContent}>
            6) at our request, you will provide us with written copies of any
            consents, permissions and licences that you are required to obtain.
          </p>

          <p className={classes.termsSubContent}>
            We reserve the right at our sole discretion to hide or remove any
            User Content if such content is in breach of any of the terms of
            this clause.
          </p>

          <p className={classes.termsSubContent}>
            You shall be legally liable for the User Content, and we shall not
            be responsible nor liable for any User Content under any
            circumstances, regardless of whether we had knowledge of the User
            Content.
          </p>

          <br />

          <p> Personal Information Protection </p>

          <p className={classes.termsSubContent}>
            Checkafy cares about your privacy. Our Privacy Policy covers our use
            of any information you provide. By using Checkafy Services, you
            agree that we may collect, store and use information about you in
            accordance with our Privacy Policy. You acknowledge and agree to be
            bound by the terms of our Privacy Policy.
          </p>

          <br />

          <p> Warranties </p>

          <p className={classes.termsSubContent}>
            Checkafy does not represent or warrant that:
          </p>

          <p className={classes.termsSubContent}>
            1) access to our Platforms will be uninterrupted, reliable or
            fault-free;
          </p>

          <p className={classes.termsSubContent}>
            2) content on our Platforms will be accurate, complete or reliable;
            and
          </p>

          <p className={classes.termsSubContent}>
            3) our Services will be provided with due care and skill.
          </p>

          <p className={classes.termsSubContent}>
            You agree that no data transmission over the internet can be
            guaranteed as totally secure. Whilst we strive to protect such
            information, we do not warrant and cannot ensure the security of any
            information which you transmit to us. Any information which you
            transmit to us is transmitted at your own risk.
          </p>

          <br />

          <p> Limitation of Liability </p>

          <p className={classes.termsSubContent}>
            To the extent permitted by law, Checkafy excludes all liability
            (whether arising in contract, tort or otherwise and whether or not
            due to our negligence) which we may otherwise have to you as a
            result of:
          </p>

          <p className={classes.termsSubContent}>
            1) any technical, factual, textual or typographical inaccuracies,
            errors or omissions on or relating to our Platforms and Services;
          </p>

          <p className={classes.termsSubContent}>
            2) the unavailability of our Platforms or Services; or
          </p>

          <p className={classes.termsSubContent}>
            3) any misrepresentation on or relating to our Platforms or
            Services.
          </p>

          <p className={classes.termsSubContent}>Save as required by law:</p>

          <p className={classes.termsSubContent}>
            1) we will not be liable to you for any indirect or consequential
            loss, damage or expenses, including loss of profits, business or
            goodwill, arising out of any problem you notify to us; and
          </p>

          <p className={classes.termsSubContent}>
            2) we will have no liability to pay any money to you by way of
            compensation except otherwise specified in these Terms of Service.
          </p>

          <br />

          <p> Restrictions </p>

          <p className={classes.termsSubContent}>
            You represent, warrant and covenant that you will not:
          </p>

          <p className={classes.termsSubContent}>
            1) use Checkafy Platforms or Services for any fraudulent or unlawful
            purpose;
          </p>

          <p className={classes.termsSubContent}>
            2) use Checkafy Platforms or Services to defame, abuse, harass,
            stalk, threaten or otherwise violate the rights of others, including
            without limitation others&apos; privacy rights or rights of
            publicity;
          </p>

          <p className={classes.termsSubContent}>
            3) interfere with or disrupt the operation of Checkafy Platforms or
            the servers or networks used to make Checkafy Platforms available;
            or violate any requirements, procedures, policies or regulations of
            such networks;
          </p>

          <p className={classes.termsSubContent}>
            4) transmit or otherwise make available in connection with Checkafy
            Platforms any virus, worm, Trojan horse or other computer code that
            is harmful or invasive or may or is intended to damage the operation
            of, or to monitor the use of, any hardware, software, or equipment;
          </p>

          <p className={classes.termsSubContent}>
            5) reproduce, duplicate, copy, sell, resell, or otherwise exploit
            for any commercial purposes, any portion of, use of, or access to
            Checkafy Platforms;
          </p>

          <p className={classes.termsSubContent}>
            6) modify, adapt, translate, reverse engineer, decompile or
            disassemble any portion of Checkafy Platforms;
          </p>

          <p className={classes.termsSubContent}>
            7) frame or mirror any part of Checkafy Platforms without our
            express prior written consent; and
          </p>

          <p className={classes.termsSubContent}>
            8) create a database by systematically downloading and storing the
            Content, User Content or any other content on Checkafy Platforms.
          </p>

          <br />

          <p> Termination </p>

          <p className={classes.termsSubContent}>
            Checkafy may terminate your access to Checkafy Platforms or
            registration immediately if you are in breach of any of these Terms
            of Service.
          </p>

          <p className={classes.termsSubContent}>
            Any rights that have accrued to either party at the date of
            termination will remain enforceable after termination.
          </p>

          <br />

          <p> Indemnity </p>

          <p className={classes.termsSubContent}>
            You agree to indemnify Checkafy and all of the directors, employees
            and contractors of the companies providing Checkafy Services, and
            hold us all harmless from any claim, loss, damage, cost, expense
            (including legal expenses) or other liability which may be incurred
            by us arising out of any breach of the covenants, warranties,
            representations and agreements herein.
          </p>

          <br />

          <p> Third Party Links and Websites </p>

          <p className={classes.termsSubContent}>
            Certain links on Checkafy Platforms will take you outside our
            Platforms. Links are provided for your convenience and inclusion of
            any link does not imply endorsement or approval by Checkafy of the
            linked website, its operator or its content. We are not responsible
            for the content of any website outside our Platforms.
          </p>

          <br />

          <p> General </p>

          <p className={classes.termsSubContent}>
            By using Checkafy Platforms or Services, you agree to be bound by
            these Terms of Service.
          </p>

          <p className={classes.termsSubContent}>
            We reserve the right at any time without notice to revise the
            content on our Platforms and these Terms of Service. Any changes to
            these Terms of Service will be posted on our Platforms and by
            continuing to use our Platforms or Services following any such
            change you will signify that you agree to be bound by the revised
            Terms of Service. This right includes the right to change any of the
            documentation which forms part of these Terms of Service.
          </p>

          <p className={classes.termsSubContent}>
            We reserve the right at our sole discretion to deny users access to
            our Platforms or any part of our Platforms without notice and to
            decline to provide our Services to any user that is in breach of
            these Terms of Service.
          </p>

          <p className={classes.termsSubContent}>
            We shall not be liable to you for any breach of these Terms of
            Service or any failure to provide or delay in providing our Services
            through our Platforms resulting from any event or circumstance
            beyond our reasonable control.
          </p>

          <p className={classes.termsSubContent}>
            If any clause hereof is held invalid or unenforceable by a court of
            competent jurisdiction, such invalidity shall not affect the
            validity or operation of any other clause, and such invalid clause
            shall be deemed to be severed from these Terms of Service.
          </p>

          <p className={classes.termsSubContent}>
            We may assign these Terms of Service or appoint any third party, to
            provide the Services to you on our behalf or to perform any of our
            obligations under these Terms of Service.
          </p>

          <p className={classes.termsSubContent}>
            You shall not assign or otherwise deal with its rights and
            obligations under these Terms of Service, whether in whole or in
            part without our written consent.
          </p>

          <p className={classes.termsSubContent}>
            These Terms of Service set forth the entire agreement and
            understanding of the parties and supersede all prior oral or written
            agreements, understandings or arrangements relating to the subject
            matter of these Terms of Service. Neither party shall be entitled to
            rely on any agreement, understanding or arrangement that is not
            expressly set forth in these Terms of Service.
          </p>

          <p className={classes.termsSubContent}>
            These Terms of Service are governed by the laws in force in Hong
            Kong. You agree to submit to the exclusive jurisdiction of Hong Kong
            courts.
          </p>

          <br />

          <p className={classes.termsSubContent}>
            {" "}
            Last Updated: 1 March 2021{" "}
          </p>
        </div>
      </div>
    </div>
  );
};
